<template>
  <div class="spinner-wrap">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  data() {
    return {}
  }
}
</script>


<style lang="scss" scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner {
  width: 50px;
  height: 50px;
  border: 6px solid #ccc;
  border-top: 6px solid #1d72b8;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
</style>